module.exports = __webpack_public_path__ + "img/reward.8b0a8ae9.svg";